import flow from 'lodash/flow';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logWebActivity } from 'src/common/actions/logging';
import { DOWNLOAD_DESKTOP_BUTTON } from 'src/common/constants/localizations/desktop';
import connectWithExperiments from '../../decorators/connectWithExperiments';
import ExternalLink from '../shared/link/ExternalLink';
import isWindowsDesktop from '../../utils/userAgent/isWindowsDesktop';
import isMacDesktop from '../../utils/userAgent/isMacDesktop';
import web from '../../constants/analytics/categoryActionLabel/web';
import {
  WEB_MAC_DESKTOP_HREF,
  WEB_WINDOWS_DESKTOP_HREF,
} from '../../constants/experiments/desktop';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './leftSide.module.scss';

const SidebarDesktopDownloadLink = ({
  userAgent,
  isDesktop,
  actions,
  [WEB_MAC_DESKTOP_HREF]: macDesktopHref,
  [WEB_WINDOWS_DESKTOP_HREF]: windowsDesktopHref,
}) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  if (isDesktop) {
    return null;
  }

  if (isMacDesktop(userAgent)) {
    return (
      <div
        id="macDesktopLinkContainer"
        data-testid="macDesktopLinkContainer"
        className={css.desktopLinkContainer}
      >
        <ExternalLink
          href={macDesktopHref}
          className={css.desktopLink}
          data-testid="leftSideMacDesktopLink"
          onClick={() =>
            actions.logWebActivity(web.actions.tap, web.labels.macDownloadNav)
          }
          children={getLocalizedText(DOWNLOAD_DESKTOP_BUTTON)}
        />
      </div>
    );
  }

  if (isWindowsDesktop(userAgent)) {
    return (
      <div
        id="windowsDesktopLinkContainer"
        data-testid="windowsDesktopLinkContainer"
        className={css.desktopLinkContainer}
      >
        <ExternalLink
          href={windowsDesktopHref}
          className={css.desktopLink}
          data-testid="leftSideWindowsDesktopLink"
          onClick={() =>
            actions.logWebActivity(
              web.actions.tap,
              web.labels.windowsDownloadNav,
            )
          }
          children={getLocalizedText(DOWNLOAD_DESKTOP_BUTTON)}
        />
      </div>
    );
  }

  return null;
};

SidebarDesktopDownloadLink.propTypes = {
  userAgent: PropTypes.string.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired,
  [WEB_MAC_DESKTOP_HREF]: PropTypes.string,
  [WEB_WINDOWS_DESKTOP_HREF]: PropTypes.string,
};

export const mapStateToProps = ({ app }) => ({
  userAgent: app.userAgent,
  isDesktop: app.isDesktop,
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        logWebActivity,
      },
      dispatch,
    ),
  };
}

export default flow(
  connect(mapStateToProps, mapDispatchToProps),
  connectWithExperiments([WEB_MAC_DESKTOP_HREF, WEB_WINDOWS_DESKTOP_HREF]),
)(SidebarDesktopDownloadLink);
